import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import OverflowModal from '../../../../Components/overflowModal';
import SpinnerButton from '../../../../Components/SpinnerButton';

const API_URL = process.env.REACT_APP_API_URL
class ModalBuscaPersona extends Component {

  constructor(props) {
    super(props);
    this.state = { data: [], show: false, insert: true, personaEntrevistada: props.personaEntrevistada };
    this.selectPersona = this.selectPersona.bind(this);
  }

  async componentDidMount() {
    await this.refreshData();
  }

  async refreshData() {
    this.setState({ show: false });
    try {
      const response = await fetch(`${API_URL}/persona/getAll`);
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const personas = await response.json();
      this.setState({ data: personas });
    } catch (err) {
      console.log(err.message);
    };
  }

  async onChange(e) {
    const busqueda = { buscar: e.target.value }
    try {
      const response = await fetch(`${API_URL}/persona/search`, {
        method: 'POST',
        body: JSON.stringify(busqueda),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const personas = await response.json();
      if (response.status >= 200 && response.status < 300) {
        this.setState({ data: personas })
      }
      else {
        console.log(personas);
      }
    } catch (err) {
      console.log("se murio");
    }
  }

  handleClose() {
    this.refreshData();
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  async selectPersona(post) {
    await this.props.seleccionaPersona(post);
    this.handleClose();
  }

  render() {

    var moment = require('moment');

    return (
      <>
        <Button variant="primary" onClick={() => { this.handleShow() }}>
          {this.props.children}
        </Button>

        <Modal show={this.state.show} onHide={() => { this.handleClose() }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>{this.props.titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Form.Group controlId="formSearch">
                  <FloatingLabel
                    controlId="buscaPersona"
                    label="Buscar Persona"
                    className="mb-3"
                  >
                    <Form.Control type="text" onChange={(e) => { this.onChange(e) }} placeholder="Buscar Persona" />
                  </FloatingLabel>
                </Form.Group>
              </Row>
              <Row>
                <OverflowModal>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Alias</th>
                        <th>Nombre</th>
                        <th>Eventos</th>
                        <th>Fecha Registro</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.data.map(post =>
                          <tr key={post._id}>
                            <td>{post.alias}</td>
                            <td>{post.nombre}{' '}{post.primerApellido}{' '}{post.segundoApellido}</td>
                            <td></td>
                            <td>{moment(post.fechaRegistro).format('YYYY-MM-DD')}</td>
                            <td>
                              <SpinnerButton onClick={this.selectPersona} item={post}>Seleccionar</SpinnerButton>
                            </td>
                          </tr>
                        )
                      }
                    </tbody>
                  </Table>
                </OverflowModal>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => { this.handleClose() }}>
                Cancelar
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  }
}

export default ModalBuscaPersona